const CHUNK_SIZE = 3 * 1024 * 1024; // 3MB — safely under Vercel's 4.5MB function payload limit

export async function uploadToFtp(
  file: File,
  folder: string,
  subfolder?: string,
  onProgress?: (percent: number) => void
): Promise<string> {
  if (file.size <= CHUNK_SIZE) {
    return uploadSingle(file, folder, subfolder, onProgress);
  }
  return uploadChunked(file, folder, subfolder, onProgress);
}

function uploadSingle(
  file: File,
  folder: string,
  subfolder?: string,
  onProgress?: (percent: number) => void
): Promise<string> {
  return new Promise((resolve, reject) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("folder", folder);
    if (subfolder) formData.append("subfolder", subfolder);

    const xhr = new XMLHttpRequest();

    xhr.upload.addEventListener("progress", (e) => {
      if (e.lengthComputable && onProgress) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    });

    xhr.addEventListener("load", () => {
      if (xhr.status >= 200 && xhr.status < 300) {
        try {
          resolve(JSON.parse(xhr.responseText).url);
        } catch {
          reject(new Error("Sunucu yanıtı okunamadı"));
        }
      } else {
        try {
          reject(new Error(JSON.parse(xhr.responseText).error || "Dosya yüklenemedi"));
        } catch {
          reject(new Error(`Yükleme hatası (${xhr.status})`));
        }
      }
    });

    xhr.addEventListener("error", () => reject(new Error("Bağlantı hatası")));
    xhr.addEventListener("abort", () => reject(new Error("Yükleme iptal edildi")));

    xhr.open("POST", "/api/upload");
    xhr.send(formData);
  });
}

async function uploadChunked(
  file: File,
  folder: string,
  subfolder?: string,
  onProgress?: (percent: number) => void
): Promise<string> {
  const totalChunks = Math.ceil(file.size / CHUNK_SIZE);
  const uploadId = `${Date.now()}-${Math.round(Math.random() * 1e6)}`;
  let finalUrl = "";

  for (let i = 0; i < totalChunks; i++) {
    const start = i * CHUNK_SIZE;
    const end = Math.min(start + CHUNK_SIZE, file.size);
    const chunk = file.slice(start, end);

    const formData = new FormData();
    formData.append("file", new Blob([chunk], { type: file.type }), file.name);
    formData.append("folder", folder);
    if (subfolder) formData.append("subfolder", subfolder);
    formData.append("uploadId", uploadId);
    formData.append("chunkIndex", String(i));
    formData.append("totalChunks", String(totalChunks));

    const response = await fetch("/api/upload", { method: "POST", body: formData });

    if (!response.ok) {
      const err = await response.json().catch(() => ({}));
      throw new Error(err.error || `Parça ${i + 1}/${totalChunks} yüklenemedi`);
    }

    const data = await response.json();
    if (data.url) finalUrl = data.url;

    if (onProgress) onProgress(Math.round(((i + 1) / totalChunks) * 100));
  }

  return finalUrl;
}
